/**
 * 宅吉 · 统一导览菜单（阿里云 zhaiji.cc + Shopify shop.zhaiji.net）
 * 规格见：docs/统一navigation跳转.md
 *
 * Shopify 菜单可填外链（https://zhaiji.cc/...），与阿里云完全一致。
 */
(function (global) {
  const SHOP_ORIGIN = 'https://shop.zhaiji.net';
  /** 阿里云：中文首页 + 吉宅测算 Step1–4 + 报告 */
  const ALI_ORIGIN = 'https://zhaiji.net';
  /** 正式宣传域（可选，与 zhaiji.net 同步时再改） */
  const MARKETING_PROD = 'https://zhaiji.net';

  function hostKind() {
    const h = global.location.hostname;
    if (h === 'shop.zhaiji.net' || h.endsWith('.myshopify.com')) return 'shop';
    if (h === 'zhaiji.cc' || h === 'www.zhaiji.cc' || h === 'zhaiji.net' || h === 'www.zhaiji.net' || h === 'localhost' || h === '127.0.0.1') {
      return 'ali';
    }
    return 'marketing';
  }

  function aliBase() {
    if (hostKind() === 'ali') return global.location.origin.replace(/\/$/, '');
    return ALI_ORIGIN;
  }

  function marketingOrigin() {
    const k = hostKind();
    if (k === 'ali') return aliBase();
    if (k === 'shop') return aliBase();
    return MARKETING_PROD;
  }

  function calcOrigin() {
    if (hostKind() === 'shop') return ALI_ORIGIN;
    if (hostKind() === 'ali') return global.location.origin.replace(/\/$/, '');
    return ALI_ORIGIN;
  }

  function memberHref() {
    return calcOrigin() + '/member.html';
  }

  function contentHubHref() {
    return calcOrigin() + '/member.html?from=shop-account';
  }

  function shopAccountHref() {
    return SHOP_ORIGIN + '/account';
  }

  function shopLoginHref() {
    return SHOP_ORIGIN + '/account/login';
  }

  function calcHref() {
    if (hostKind() === 'shop') return '/apps/9palace/';
    return aliBase() + '/calc-guide.html';
  }

  /**
   * site: 'ali' → 始终 zhaiji.net（测算/中文内容；zhaiji.cc 为测试站同逻辑）
   * site: 'shop' → shop.zhaiji.net
   * site: 'auto' → 按当前 host
   * site: 'calc' → 按环境：shop 下走 App Proxy，否则走 ali
   */
  const MENU_GROUPS = [
    {
      label: '风水知识',
      items: [
        { label: '风水文章', homeHash: 'articles', site: 'ali' },
        { label: '风水美学', homeHash: 'services', site: 'ali' },
      ],
    },
    {
      label: '风水吉宅测算',
      items: [
        { label: '付费吉宅报告', path: '/calc-guide.html', site: 'calc' },
        { label: '商城购买报告', path: '/products/zhaiji-home-feng-shui-report', site: 'shop' },
      ],
    },
    {
      label: '会员服务',
      items: [
        { label: '内容中心（报告/电子书）', path: '/member.html', site: 'ali' },
        { label: '商城订单', path: '/account', site: 'shop' },
        { label: '加入会员', path: '/collections/all', site: 'shop' },
        { label: '每日指引', homeHash: 'matrix', site: 'ali' },
      ],
    },
    {
      label: '宅吉商城',
      items: [
        { label: '产品目录', path: '/products', site: 'shop' },
      ],
    },
    {
      label: '合作联系',
      items: [
        { label: '留言与邮箱', homeHash: 'contact', site: 'ali' },
      ],
    },
  ];

  const MENU_GROUPS_EN = [
    {
      label: 'Feng Shui insights',
      items: [
        { label: 'Articles', path: '/articles/index-en.html', site: 'ali' },
        { label: 'Spatial aesthetics', path: '/index-en.html#services', site: 'ali' },
      ],
    },
    {
      label: 'Home energy reading',
      items: [
        { label: 'Full space report', path: '/step1-upload.html', site: 'ali' },
        { label: 'Shop reports', path: '/products/zhaiji-home-feng-shui-report', site: 'shop' },
      ],
    },
    {
      label: 'Membership',
      items: [
        { label: 'Content hub (reports/e-books)', path: '/member.html', site: 'ali' },
        { label: 'Shop orders', path: '/account', site: 'shop' },
        { label: 'Join membership', path: '/collections/all', site: 'shop' },
        { label: 'Daily guidance', path: '/index-en.html#matrix', site: 'ali' },
      ],
    },
    {
      label: 'Shop',
      items: [
        { label: 'All products', path: '/products', site: 'shop' },
      ],
    },
    {
      label: 'Contact',
      items: [
        { label: 'Message us', path: '/index-en.html#contact', site: 'ali' },
      ],
    },
  ];

  function currentLocale() {
    if (global.ZhaijiLocale && global.ZhaijiLocale.get) {
      return global.ZhaijiLocale.get();
    }
    return 'zh';
  }

  /** 首页区块锚点（本周精选 #articles 等），避免 /#hash 拼接异常 */
  function homeSectionHref(sectionId) {
    var loc = currentLocale();
    var page = loc === 'en' ? '/index-en.html' : '/';
    var base = aliBase().replace(/\/$/, '');
    try {
      var u = new URL(page, base + '/');
      u.hash = String(sectionId || '').replace(/^#/, '');
      var href = u.toString();
      if (global.ZhaijiLocale && global.ZhaijiLocale.withLang) {
        href = global.ZhaijiLocale.withLang(href, loc);
      }
      return href;
    } catch (e) {
      return base + page + '#' + String(sectionId || '').replace(/^#/, '');
    }
  }

  function resolveHref(item) {
    const site = item.site || 'auto';
    const path = item.path || '/';

    if (item.homeHash && site === 'ali') {
      return homeSectionHref(item.homeHash);
    }

    if (site === 'ali') return aliBase() + path;
    if (site === 'shop') return SHOP_ORIGIN + path;
    if (site === 'calc') return calcHref();

    if (hostKind() === 'shop') {
      return path.startsWith('/') && !path.startsWith('//') ? SHOP_ORIGIN + path : path;
    }
    return aliBase() + path;
  }

  function getMenuItems(loc) {
    var locale = loc || currentLocale();
    var groups = locale === 'en' ? MENU_GROUPS_EN : MENU_GROUPS;
    return groups.map(function (group) {
      return {
        label: group.label,
        items: group.items.map(function (item) {
          var href = resolveHref(item);
          if (global.ZhaijiLocale && global.ZhaijiLocale.withLang) {
            href = global.ZhaijiLocale.withLang(href, locale);
          }
          return { label: item.label, href: href };
        }),
      };
    });
  }

  function logoHref() {
    if (hostKind() === 'shop') return SHOP_ORIGIN + '/';
    var loc = currentLocale();
    if (loc === 'en') return aliBase() + '/index-en.html';
    return aliBase() + '/';
  }

  global.ZhaijiNavConfig = {
    MENU_GROUPS,
    MENU_GROUPS_EN,
    getMenuItems,
    logoHref,
    memberHref,
    contentHubHref,
    shopAccountHref,
    shopLoginHref,
    marketingOrigin,
    calcOrigin,
    aliOrigin: () => aliBase(),
    shopOrigin: () => SHOP_ORIGIN,
    hostKind,
    ALI_ORIGIN,
    SHOP_ORIGIN,
  };
})(typeof window !== 'undefined' ? window : globalThis);
